"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("../../../stylesheets/components/common/CustomCheckbox.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clientErrorLogger = _interopRequireDefault(require("../../../util/clientErrorLogger"));

var _CustomError = _interopRequireDefault(require("./CustomError"));

var _FormField = _interopRequireDefault(require("../../mixins/FormField"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var CustomCheckbox = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomCheckbox, _React$Component);

  var _super = _createSuper(CustomCheckbox);

  function CustomCheckbox() {
    _classCallCheck(this, CustomCheckbox);

    return _super.call(this);
  } // adapted from FormField.handleChange


  _createClass(CustomCheckbox, [{
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(e) {
      if (!this.inputElement) {
        _clientErrorLogger.default.notify("No input element defined for form field", "error");

        return;
      }

      this.value = this.inputElement.checked;
      this.updateBackingValue(false);

      if ((0, _isFunction.default)(this.props.onChange)) {
        this.props.onChange(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fieldName = _this$props.fieldName,
          label = _this$props.label,
          id = _this$props.id,
          name = _this$props.name;
      var checkboxId = id || "chk-" + fieldName;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames("custom-checkbox-container")
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        id: checkboxId,
        className: "custom-checkbox",
        type: "checkbox",
        name: name || fieldName,
        ref: this.setInputRef,
        value: fieldName,
        checked: this.readValue(),
        onChange: this.handleCheckboxChange
      }, this.getInnerInputProps())), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: checkboxId,
        className: "custom-checkbox-label"
      }, label), /*#__PURE__*/_react.default.createElement(_CustomError.default, {
        errors: this.getErrors()
      }));
    }
  }]);

  return CustomCheckbox;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  label: _propTypes.default.node.isRequired,
  onChange: _propTypes.default.func
}), _defineProperty(_class2, "defaultProps", {
  inConverter: function inConverter(value) {
    return value;
  }
}), _defineProperty(_class2, "defaultProps", {
  inConverter: function inConverter(value) {
    return value;
  }
}), _defineProperty(_class2, "defaultProps", {
  inConverter: function inConverter(value) {
    return value;
  }
}), _class2), (_applyDecoratedDescriptor(_class.prototype, "handleCheckboxChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleCheckboxChange"), _class.prototype)), _class); // FormField makes this an observer

var _default = (0, _FormField.default)(CustomCheckbox);

exports.default = _default;